const AnimatedArrowRight = ({ color = 'currentColor', size = 14 }: { color?: string; size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" aria-hidden="true">
    <path
      d="M5 10L14 10"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      className="[stroke-dasharray:50] [stroke-dashoffset:50] transition-all duration-200 ease-in group-hover:[stroke-dashoffset:0] group-hover:delay-100"
    />
    <path
      d="M8 14L12 10"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      className="transition-all duration-200 ease-in delay-100 group-hover:translate-x-[3px] group-hover:delay-0"
    />
    <path
      d="M12 10L8 6"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      className="transition-all duration-200 ease-in delay-100 group-hover:translate-x-[3px] group-hover:delay-0"
    />
  </svg>
);

export default AnimatedArrowRight;
